@if (loading) {
  <div class="page-loading">
    <span>
      <span></span>
    </span>
  </div>
}
<div>
  <div>
    <h1>
      <span class="fa fa-search"></span> Search Results
      <small>"{{ searchTerm }}"</small>
    </h1>
  </div>
  @if (listings && listings.length < 1 && !loading) {
    <div class="small-12 columns">
      <p>No results found for: "{{ searchTerm }}"</p>
    </div>
  }
  @if (listings) {
    <div>
      <product-list [items]="listings"></product-list>
    </div>
  }
</div>
